(function () {
  function rafThrottle(fn) {
    let id = 0;
    return function () {
      if (id) return;
      id = requestAnimationFrame(function () {
        id = 0;
        fn();
      });
    };
  }

  function parseJson(node) {
    if (!node) return [];
    try {
      return JSON.parse(node.textContent || '[]') || [];
    } catch (e) {
      return [];
    }
  }

  function formatMoney(cents, format) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, format);
    }
    const amount = (Number(cents || 0) / 100).toFixed(2);
    if (format && format.indexOf('{{amount}}') > -1) return format.replace('{{amount}}', amount);
    return amount;
  }

  function init(el) {
    if (el.getAttribute('data-sticky-initialized') === 'true') return;
    el.setAttribute('data-sticky-initialized', 'true');

    if (!el.hasAttribute('data-portalized')) {
      document.body.appendChild(el);
      el.setAttribute('data-portalized', 'true');
    }

    el.style.display = '';

    const sectionRoot = document.getElementById(el.getAttribute('data-target-id')) || el.closest('.product-section') || document;
    const mainForm = document.getElementById(el.getAttribute('data-main-form-id')) || sectionRoot.querySelector('form[id^="AddToCartForm-"]') || sectionRoot.querySelector('form[action="/cart/add"]');
    if (!mainForm) return;

    const behavior = el.getAttribute('data-behavior') || 'add_to_cart';
    const triggerMode = el.getAttribute('data-trigger-mode') || 'form';
    const triggerPercent = Math.min(100, Math.max(0, parseFloat(el.getAttribute('data-trigger-scroll-percent') || '30')));
    const stickyForm = el.querySelector('form');
    const moneyFormat = el.getAttribute('data-money-format') || '';
    const stickyVariantJson = parseJson(el.querySelector('[data-sticky-variants]'));
    const sectionVariantJson = parseJson(sectionRoot.querySelector('[data-variant-json]'));
    const variants = stickyVariantJson.length ? stickyVariantJson : sectionVariantJson;
    const button = el.querySelector('button[name="add"]');
    const stickyIdField = el.querySelector('[data-sticky-variant-id]');
    const priceWrap = el.querySelector('[data-sticky-price]');
    const currentPriceEl = el.querySelector('[data-sticky-current-price]');
    const comparePriceEl = el.querySelector('[data-sticky-compare-price]');
    const variantWrap = el.querySelector('.sticky-atc__details__variant');
    const variantTitleEl = el.querySelector('.sticky-atc__details__variant__title');
    const optionSelects = Array.from(el.querySelectorAll('.sticky-atc__select'));
    const imgWrap = el.querySelector('.sticky-atc__image');
    const getVariantIdField = function () {
      return mainForm.querySelector('input[name="id"], select[name="id"]');
    };

    function headerOffset() {
      const h = document.querySelector('.section-header') || document.querySelector('.site-header');
      return h ? h.offsetHeight : 0;
    }

    function setBottomOffset() {
      const vv = window.visualViewport;
      let offset = 0;
      if (vv) offset = Math.max(0, window.innerHeight - (vv.height + vv.offsetTop));
      const prev = parseFloat(el.getAttribute('data-bottom-offset') || '0');
      if (Math.abs(prev - offset) < 2) return;
      el.setAttribute('data-bottom-offset', String(offset));
      el.style.setProperty('--sticky-atc-bottom', offset + 'px');
    }

    function scrollState() {
      const doc = document.documentElement;
      const scrollTop = window.pageYOffset || doc.scrollTop || 0;
      const viewportH = window.innerHeight || doc.clientHeight || 0;
      const docH = Math.max(doc.scrollHeight, document.body.scrollHeight);
      const scrollable = Math.max(0, docH - viewportH);
      const progress = scrollable ? (scrollTop / scrollable) * 100 : 100;
      const bottomProgress = docH ? (scrollTop + viewportH) / docH : 0;
      return { progress: progress, bottomProgress: bottomProgress };
    }

    function setFooterHide() {
      const state = scrollState();
      document.documentElement.classList.toggle('scrolled-to-bottom', state.bottomProgress >= 0.9);
    }

    const onScroll = rafThrottle(function () {
      const state = scrollState();
      const rect = mainForm.getBoundingClientRect();
      const hide = triggerMode === 'percent' ? state.progress < triggerPercent : rect.top > headerOffset();
      el.classList.toggle('sticky-atc--out', hide);
      setFooterHide();
      setBottomOffset();
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);

    if (window.visualViewport) {
      window.visualViewport.addEventListener('scroll', onScroll, { passive: true });
      window.visualViewport.addEventListener('resize', onScroll);
    }

    function variantById(id) {
      if (!id) return null;
      return variants.find(function (v) {
        return String(v.id) === String(id);
      }) || null;
    }

    function selectedOptionValues() {
      const values = [];
      sectionRoot.querySelectorAll('fieldset.variant-input-wrap').forEach(function (fs) {
        const r = fs.querySelector('input[type="radio"][name]:checked');
        const s = fs.querySelector('select[name]');
        const val = r ? r.value : (s ? s.value : '');
        if (val) values.push(val);
      });
      if (!values.length) {
        optionSelects.forEach(function (sel) {
          if (sel.value) values.push(sel.value);
        });
      }
      return values;
    }

    function variantByOptions(values) {
      if (!values.length) return null;
      return variants.find(function (v) {
        const opts = v.options || [v.option1, v.option2, v.option3].filter(Boolean);
        for (let i = 0; i < values.length; i += 1) {
          if (values[i] && opts[i] !== values[i]) return false;
        }
        return true;
      }) || null;
    }

    function selectedVariant() {
      const idField = getVariantIdField();
      const fromId = idField && idField.value ? variantById(idField.value) : null;
      if (fromId) return fromId;
      return variantByOptions(selectedOptionValues());
    }

    function syncVariantTitle(variant) {
      if (!variantTitleEl) return;
      let txt = '';
      if (variant && variant.options && variant.options.length) txt = variant.options[0] || '';
      if (!txt) {
        const firstChecked = sectionRoot.querySelector('fieldset.variant-input-wrap input[type="radio"][name]:checked');
        if (firstChecked) txt = firstChecked.value || '';
      }
      variantTitleEl.textContent = txt;
      if (variantWrap) variantWrap.hidden = !txt;
    }

    function syncSelectsFromVariant(variant) {
      if (!variant || !variant.options) return;
      optionSelects.forEach(function (sel, index) {
        if (variant.options[index]) sel.value = variant.options[index];
      });
    }

    function syncSelectsFromMain() {
      optionSelects.forEach(function (sel) {
        const name = sel.getAttribute('data-option-name');
        let val = '';
        sectionRoot.querySelectorAll('fieldset.variant-input-wrap input[type="radio"][name]').forEach(function (input) {
          if (input.name === name && input.checked) val = input.value;
        });
        if (!val) {
          sectionRoot.querySelectorAll('fieldset.variant-input-wrap select[name]').forEach(function (select) {
            if (select.name === name) val = select.value;
          });
        }
        if (val) sel.value = val;
      });
    }

    function updatePrice(variant) {
      if (!priceWrap || !currentPriceEl || !variant) return;
      const price = Number(variant.price || 0);
      const compare = Number(variant.compare_at_price || 0);
      const onSale = compare > price;
      currentPriceEl.innerHTML = formatMoney(price, moneyFormat);
      if (comparePriceEl) {
        comparePriceEl.innerHTML = formatMoney(compare, moneyFormat);
        comparePriceEl.hidden = !onSale;
      }
      priceWrap.classList.toggle('sticky-atc__price--sale', onSale);
      priceWrap.classList.toggle('sticky-atc__price--regular', !onSale);
    }

    function updateButton(variant) {
      if (!button) return;
      const addText = button.getAttribute('data-add-to-cart-text') || button.textContent;
      const soldOutText = button.getAttribute('data-sold-out-text') || 'Out of stock';
      const unavailableText = button.getAttribute('data-unavailable-text') || addText;
      if (!variant) {
        button.textContent = unavailableText;
        button.disabled = true;
        button.classList.add('sticky-atc__btn--sold-out');
        return;
      }
      if (variant.available) {
        button.textContent = addText;
        button.disabled = false;
        button.classList.remove('sticky-atc__btn--sold-out');
      } else {
        button.textContent = soldOutText;
        button.disabled = true;
        button.classList.add('sticky-atc__btn--sold-out');
      }
    }

    function updateStickyVariantId(variant) {
      if (stickyIdField && variant && variant.id) stickyIdField.value = String(variant.id);
    }

    function updateState(variant) {
      if (!variant) variant = selectedVariant();
      updateStickyVariantId(variant);
      updatePrice(variant);
      updateButton(variant);
      syncVariantTitle(variant);
      syncSelectsFromVariant(variant);
    }

    el.addEventListener('change', function (e) {
      const sel = e.target.closest('.sticky-atc__select');
      if (!sel) return;
      const name = sel.getAttribute('data-option-name');
      const value = sel.value;

      sectionRoot.querySelectorAll('fieldset.variant-input-wrap input[type="radio"][name]').forEach(function (radio) {
        if (radio.name === name && radio.value === value) {
          if (!radio.checked) radio.checked = true;
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      sectionRoot.querySelectorAll('fieldset.variant-input-wrap select[name]').forEach(function (select) {
        if (select.name === name) {
          if (select.value !== value) select.value = value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      const variant = variantByOptions(optionSelects.map(function (select) { return select.value; }));
      updateState(variant);
      burstUpdateImg();
      setTimeout(function () {
        syncSelectsFromMain();
        updateState(selectedVariant());
      }, 0);
    });

    let lastSrc = '';

    function getActiveMainImg() {
      const sels = [
        '.product__main-photos .product-main-slide.is-selected picture img',
        '.product__main-photos .product-main-slide.is-selected img',
        '.product__main-photos [aria-hidden="false"] img',
        '.product__main-photos img',
        '.product__photos img',
        '[data-product-single-media-wrapper][aria-hidden="false"] img',
        '[data-product-single-media-wrapper] img'
      ];
      for (let i = 0; i < sels.length; i += 1) {
        const node = sectionRoot.querySelector(sels[i]);
        if (node && (node.currentSrc || node.src)) return node;
      }
      return null;
    }

    const updateImg = rafThrottle(function () {
      if (!imgWrap) return;
      const img = getActiveMainImg();
      if (!img) return;
      const newSrc = img.currentSrc || img.src || '';
      if (!newSrc || newSrc === lastSrc) return;
      let stickyImg = imgWrap.querySelector('img');
      if (!stickyImg) {
        stickyImg = document.createElement('img');
        stickyImg.loading = 'lazy';
        if ('decoding' in stickyImg) stickyImg.decoding = 'async';
        imgWrap.innerHTML = '';
        imgWrap.appendChild(stickyImg);
      }
      stickyImg.alt = img.alt || '';
      stickyImg.src = newSrc;
      lastSrc = newSrc;
      img.addEventListener('load', function () {
        const latest = img.currentSrc || img.src || '';
        if (latest && latest !== lastSrc) {
          stickyImg.src = latest;
          lastSrc = latest;
        }
      }, { once: true });
    });

    function burstUpdateImg() {
      updateImg();
      setTimeout(updateImg, 60);
      setTimeout(updateImg, 150);
      setTimeout(updateImg, 300);
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('.product__thumb') || e.target.closest('[data-product-thumb]')) setTimeout(burstUpdateImg, 60);
    });

    mainForm.addEventListener('change', function (e) {
      if (e.target && (e.target.name === 'id' || e.target.closest('fieldset.variant-input-wrap'))) {
        syncSelectsFromMain();
        setTimeout(function () { updateState(selectedVariant()); }, 0);
        burstUpdateImg();
      }
    });

    document.addEventListener('variant:change', function (e) {
      if (e.detail && e.detail.variant) updateState(e.detail.variant);
      burstUpdateImg();
    });

    const idField = getVariantIdField();
    if (idField && 'MutationObserver' in window) {
      new MutationObserver(function () {
        updateState(selectedVariant());
      }).observe(idField, { attributes: true, attributeFilter: ['value'] });
    }

    const gallery = sectionRoot.querySelector('.product__main-photos') || sectionRoot;
    if ('MutationObserver' in window && gallery) {
      new MutationObserver(burstUpdateImg).observe(gallery, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['class', 'src', 'srcset', 'data-current', 'data-media-id', 'aria-hidden', 'style']
      });
    }

    function submitMain(variantId) {
      let idField = getVariantIdField();
      if (!idField) {
        idField = document.createElement('input');
        idField.type = 'hidden';
        idField.name = 'id';
        mainForm.appendChild(idField);
      }
      if (variantId) idField.value = String(variantId);
      const btn = mainForm.querySelector('button[name="add"]');
      if (typeof mainForm.requestSubmit === 'function') {
        try {
          if (btn) btn.disabled = false;
          mainForm.requestSubmit(btn || null);
        } catch (e) {
          btn ? btn.click() : mainForm.submit();
        }
      } else if (btn) {
        btn.click();
      } else {
        mainForm.submit();
      }
      setTimeout(function () {
        const html = document.documentElement;
        const drawer = document.getElementById('CartDrawer') || document.querySelector('[id*="CartDrawer"]');
        const isOpen = html.classList.contains('js-drawer-open') || (drawer && drawer.classList.contains('is-open')) || (drawer && drawer.getAttribute('aria-hidden') === 'false');
        if (!isOpen && drawer) {
          drawer.classList.add('is-open');
          html.classList.add('js-drawer-open', 'js-drawer-open-right');
        }
      }, 800);
    }

    function onStickySubmit(e) {
      if (behavior === 'scroll') return;
      e.preventDefault();
      const variant = selectedVariant();
      if (!variant || !variant.available) {
        mainForm.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      submitMain(variant.id);
    }

    if (stickyForm) stickyForm.addEventListener('submit', onStickySubmit);

    syncSelectsFromMain();
    updateState(selectedVariant());
    burstUpdateImg();
    setBottomOffset();
    setFooterHide();
    requestAnimationFrame(onScroll);
  }

  function initAll() {
    document.querySelectorAll('sticky-atc').forEach(init);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
})();
